export enum CheckboxType {
    PRIMARY = "primary",
    ERROR = "error",
}
